







import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander } from '@/components/table'
import { QueryManageCommentList, UpdateCommentDisplayStatus } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class CommentList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    sortType: 0,
    goodsId: undefined,
    goodsName: '',
    goodsCode: '',
    orderCode: '',
    userId: undefined,
    userName: '',
    displayStatus: undefined,
    score01: undefined,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '商品ID', param: 'goodsId' },
    { title: '商品名称', param: 'goodsName' },
    { title: '商品编号', param: 'goodsCode' },
    { title: '订单号', param: 'orderCode' },
    { title: '用户ID', param: 'userId' },
    { title: '用户昵称', param: 'userName' },
    { title: '评分', param: 'score01', type: 'select', selectData: constant.CommentScoreOptions },
    { title: '显示状态', param: 'displayStatus', type: 'select', selectData: constant.CommentDisplayStatus },
    { title: '评论时间', param: 'createTimeDaterange', type: 'daterange' },
    { title: '排序方式', param: 'sortType', type: 'select', selectData: constant.CommentSortType },
  ]

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index', width: 60 },
    { title: '商品ID', param: 'goodsId', minWidth: 90 },
    { title: '商品编号', param: 'goodsCode', overflow: true, minWidth: 130 },
    { title: '商品名称', param: 'goodsName', overflow: true, minWidth: 140 },
    { title: '订单号', param: 'orderCode', overflow: true, minWidth: 160 },
    { title: '用户ID', param: 'userId', minWidth: 90 },
    { title: '用户昵称', param: 'nickname', overflow: true, minWidth: 110 },
    { title: '评分', param: 'score01', width: 70 },
    { title: '评论内容', param: 'note', overflow: true, minWidth: 200 },
    {
      title: '评论图片',
      param: 'commentBanners',
      type: 'image',
      width: 80,
      formatter: (val: string) => this.firstBanner(val),
    },
    { title: '显示状态', param: 'displayStatus', width: 90, formatter: this.formatDisplayStatus },
    { title: '评论时间', param: 'createTime', formatter: DateFormat, minWidth: 160 },
    {
      title: '操作',
      width: 100,
      operation: [
        { title: '隐藏', click: this.hideComment, show: (row: any) => row.displayStatus === 1 },
        { title: '显示', click: this.showComment, show: (row: any) => row.displayStatus !== 1 },
      ],
    },
  ]

  public created() {
    this.loadData()
  }

  private firstBanner(val: string) {
    if (!val) {
      return ''
    }
    return val.split(',')[0]
  }

  private formatDisplayStatus(val: number) {
    return val === 1 ? '显示' : '隐藏'
  }

  private hideComment(row: any) {
    this.toggleDisplay(row, 0)
  }

  private showComment(row: any) {
    this.toggleDisplay(row, 1)
  }

  private toggleDisplay(row: any, displayStatus: number) {
    const action = displayStatus === 1 ? '显示' : '隐藏'
    MessageBox.confirm(`确定要${action}该评论吗？`, '提示', { type: 'warning' }).then(async () => {
      const ok = await UpdateCommentDisplayStatus({ id: row.id, displayStatus })
      if (ok) {
        Message.success('操作成功')
        this.loadData()
      }
    })
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    delete param.createTimeDaterange
    param.orderBy = this.buildOrderBy(param.sortType)
    delete param.sortType
    if (param.goodsId === '' || param.goodsId === null) {
      delete param.goodsId
    }
    if (param.userId === '' || param.userId === null) {
      delete param.userId
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    return param
  }

  private buildOrderBy(sortType: number) {
    switch (sortType) {
      case 1:
        return 'c.create_time asc'
      case 2:
        return 'c.score01 desc, c.create_time desc'
      case 3:
        return 'c.score01 asc, c.create_time desc'
      default:
        return 'c.create_time desc'
    }
  }

  private search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  private resetSearch() {
    this.queryParam = {
      startRow: 1,
      limit: this.queryParam.limit || 10,
      sortType: 0,
      goodsId: undefined,
      goodsName: '',
      goodsCode: '',
      orderCode: '',
      userId: undefined,
      userName: '',
      displayStatus: undefined,
      score01: undefined,
      createTimeDaterange: [],
    }
    this.tableCurrntPage = 1
    this.loadData()
  }

  private sizeChange(limit: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = limit
    this.loadData()
  }

  private pageChange(page: number) {
    this.tableCurrntPage = page
    this.loadData()
  }

  private async loadData() {
    const res = await QueryManageCommentList(this.getRequestParam())
    this.tableData = res.list || []
    this.tableTotal = res.total || 0
  }
}
